import * as TYPES from './type';
export default {
  //课中活动讨论
  [TYPES.MUTUALEVALUATE_LIST](state, { result }) {
    state.mutualEvaluateList = result.result
  },
  [TYPES.MUTUALEVALUATE_INFO](state, { result, type }) {
    state.mutualEvaluateInfo[type] = result.result
  },
   //过程性评价
   [TYPES.SCORESTURECORD_LIST](state, { result }) {
    state.scoreStuRecordList = result.result
  },
  [TYPES.SCORESTURECORD_INFO](state, { result, type }) {
    state.scoreStuRecordInfo[type] = result
  },
}